<style scoped>
    .edit-line{
        display: table;
        width: 100%;
    }
    .edit-line-item{
        display: table-cell;
    }
    .edit-line-title{
        width: 100px;
        padding: 0 8px;
        text-align: right;
    }
    .edit-line-item .ivu-input-number{
        width: 100%;
    }
</style>
<template>
  <div>
    <Table
      size="small"
      border
      stripe
      :columns="columns"
      :data="table_data"
      :loading="loading"
    />

    <Modal
      v-model="edit_config.modal"
      :title="edit_title"
      width="500"
      :loading="edit_config.loading"
      ok-text="保存"
      @on-ok="editOK"
    >
      <div
        v-for="(price, fin_team_id) in edit_data"
        v-show="isNumber(fin_team_id)"
        class="edit-line"
      >
        <span class="edit-line-item edit-line-title">
          {{ getTeamName(fin_team_id) }}
        </span>
        <span class="edit-line-item">
          <Input v-model="edit_data[fin_team_id]" />
        </span>
      </div>
    </Modal>
  </div>
</template>
<script route="/fin_report_v2/manual_input">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/fin_report_v2/manual_input',
    /* router_info_end */

    data() {
      return {
        params: {
          month: '',
          version: 2
        },
        manual_types: [],
        manual_types_hash: {},
        fin_teams: [],
        fin_teams_hash: {},
        manual_data: [],
        loading: false,
        edit_data: {},
        edit_config: {
          modal: false,
          loading: true
        }
      }
    },
    computed: {
      columns() {
        const columns = [
          {
            title: '#',
            width: 185,
            fixed: 'left',
            align: 'left',
            renderHeader: (h, params) => {
              const ret = [
                h('DatePicker', {
                  attrs: {
                    style: 'width: 120px',
                    placeholder: '选择月份',
                  },
                  props: {
                    size: 'small',
                    type: 'month',
                    value: this.getCurMonth()
                  },
                  on: {
                    'on-change': (month) => {
                      this.params.month = month;
                      this.loadData();
                    }
                  }
                }),
                h('span', ' '),
                h('Button', {
                  props: {
                    size: 'small',
                    type: 'primary'
                  },
                  on: {
                    click: () => {
                      this.loadData();
                    }
                  }
                }, '确定')
              ];
              return h('div', ret);
            },
            render:(h, params) => {
              return h('div', this.getTypeName(params.row.fin_expense_type_id));
            }
          }
        ];
        this.fin_teams.forEach((team) => {
          const column_data = {
            title: team.name,
            width: 120,
            align: 'center',
          };
          this.manual_types.forEach((type) => {
            column_data['render'] = (h, params) => {
              let price = params.row[team.id];
              price = price ? Util.formatPrice(price) : '-';
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, price);
            }
          });
          columns.push(column_data);
        });
        columns.push({
          title: '操作',
          width: 120,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const ret = [];
            const row = params.row;
            ret.push(h('Button', {
              props: {
                size: 'small',
                type: 'text'
              },
              on: {
                click: () => {
                  this.editExpenseData(params.row);
                }
              }
            }, '填写'));
            return h('div', ret);
          }
        });
        return columns;
      },
      table_data() {
        const data = [];
        this.manual_data.forEach((type_data) => {
          const row_data = type_data;
          this.fin_teams.forEach((team) => {
            if (!row_data[team.id]) {
              row_data[team.id] = ''
            }
          });
          data.push(row_data);
        });
        console.log(data);
        return data;
      },
      edit_title() {
        return `[${this.edit_data.month}] ${this.getTypeName(this.edit_data.fin_expense_type_id)}`
      }
    },
    created() {
      this.getManualTypes();
      this.getFinTeams();
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        this.params.month = this.getCurMonth();
        this.loadData();
      },
      loadData() {
        this.getManualData();
      },
      getManualTypes() {
        Util.ajax.get(Util.api.get_fin_expense_manual_types, {
          params: {version: 2}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.forEach((expense_type) => {
              this.manual_types.push(expense_type);
              this.manual_types_hash[expense_type.id] = expense_type;
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      getFinTeams() {
        Util.ajax.get(Util.api.get_fin_teams, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.forEach((team) => {
              this.fin_teams.push(team);
              this.fin_teams_hash[team.id] = team;
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      getManualData() {
        this.loading = true;
        Util.ajax.get(Util.api.fin_team_expense_manual_data, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          this.manual_data = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((fin_expense_type_data) => {
              this.manual_data.push(fin_expense_type_data);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          console.log(e);
        });
      },
      getTeamName(id) {
        const team = this.fin_teams_hash[id];
        return team ? team.name : '-';
      },
      getTypeName(id) {
        const type = this.manual_types_hash[id];
        return type ? type.name : '-';
      },
      getCurMonth() {
        return moment().format('YYYY-MM');
      },
      isNumber(str) {
        const reg = /^(-?\d+)(\.\d+)?$/;
        return reg.test(str);
      },
      editExpenseData(expense_data) {
        console.log(expense_data);
        this.edit_data = Util.clone(expense_data);
        this.edit_config.modal = true;
      },
      editOK() {
        Util.ajax.post(Util.api.update_fin_team_expense_manual_data, {
          fin_expense_type_id: this.edit_data.fin_expense_type_id,
          month: this.edit_data.month,
          data: this.edit_data
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.edit_config.modal = false;
            this.loadData();
            this.$Message.success('填写成功!');
          } else {
            this.edit_config.loading = false;
            setTimeout(() => {
              this.edit_config.loading = true;
            }, 500);
            this.$Message.error(data.msg);
          }
        }).catch((e) => {
          console.log(e);
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          this.$Message.error('删除失败' + e);
        });
      }
    }
  }
</script>
